import { render, staticRenderFns } from "./FormatMessage.vue?vue&type=template&id=9cffb7b0&"
import script from "./FormatMessage.vue?vue&type=script&lang=js&"
export * from "./FormatMessage.vue?vue&type=script&lang=js&"
import style0 from "./FormatMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports